<script setup lang="ts">
import StfDivider from '@/ui/divider/StfDivider.vue';
import StfRow from '@/ui/columns/StfRow.vue';
import BillingRow from '@/components/payment-view/billing-row.vue';
import type Checkout from '@/core/model/checkout';
import { useI18n } from 'vue-i18n'
import StfCol from '@/ui/columns/StfCol.vue';
import useCountry from '@/composables/countryDependable';
const { t } = useI18n()

interface Props {
    checkout: Checkout,
    loading: boolean
}

defineProps<Props>();

const country = useCountry();
</script>

<template>
    <StfRow style="background-color: #fff;" class="p-2">
        <template v-if="loading" >
            <StfCol style="text-align: center; height: 150px;" >
                <div class="stf-loading stf-loading--action" style="margin: auto"/>
                <div class="">{{ t('message.payment.loading') }}</div>
            </StfCol>
        </template>
        <template v-else>
            <billing-row :title="'Trademark in ' + country.name" :value="checkout.application?.flatFee" heading></billing-row>
            <template v-for="productClass in checkout.application?.classes" :key="productClass.classNumber">
                <billing-row :title="`Class ${productClass.classNumber}`" :value="productClass.fee" sub-row></billing-row>
            </template>
            <StfDivider />
            <billing-row title="Subtotal" :value="checkout.application?.subTotal"></billing-row>
            <billing-row :title="t('message.price.tax')" :value="checkout.application?.tax"></billing-row>
            <StfDivider />
            <billing-row title="TOTAL" :value="checkout.total" heading></billing-row>
        </template>
    </StfRow>
</template>

<style scoped>

</style>
